import axios, { getHeaders } from "./axios";

export interface Broadcast {
  id: number;
  text: string;
  startAt: string | null;
  endAt: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface BroadcastBody {
  text: string;
  startAt?: string | null;
  endAt?: string | null;
}

export const listBroadcasts = async (): Promise<Broadcast[]> => {
  const res = await axios.get<Broadcast[]>("/broadcast", getHeaders());
  return res.data;
};

export const createBroadcast = async (body: BroadcastBody): Promise<Broadcast> => {
  const res = await axios.post<Broadcast>("/broadcast", body, getHeaders());
  return res.data;
};

export const updateBroadcast = async (id: number, body: Partial<BroadcastBody>): Promise<Broadcast> => {
  const res = await axios.patch<Broadcast>(`/broadcast/${id}`, body, getHeaders());
  return res.data;
};

export const deleteBroadcast = async (id: number): Promise<void> => {
  await axios.delete(`/broadcast/${id}`, getHeaders());
};

/** Whether a broadcast is currently active given its time window. */
export function isBroadcastLive(b: Broadcast, now = new Date()): boolean {
  const start = b.startAt ? new Date(b.startAt).getTime() : -Infinity;
  const end   = b.endAt   ? new Date(b.endAt).getTime()   :  Infinity;
  const t = now.getTime();
  return t >= start && t <= end;
}
